import { FormFieldObj } from './form-field.obj';

/**
 * un élément de rendu des combos de saisie
 * contient la référence à la FEI, et au WidgetConfigurationItemObj
 */
export class FormItemObj {
  public ffo: FormFieldObj; // référence au parent
  public value: string = ''; // la valeur du freedatavalue / chronocode
  public label: string = ''; // le libellé correspondant au code ou la valeur dans le cas d'une mesure
  public sortKey: any = ''; // la valeur pour trier les éléments

  constructor(formFieldObj: FormFieldObj, value: string, label: string, sortKey: any) {
    this.ffo = formFieldObj;
    this.value = value;
    this.label = label;
    this.sortKey = sortKey;
  }
}
